import React, { useEffect, useState } from 'react';
import { useOnlineStatus } from '../contexts/OnlineStatusContext';
import '../styles/OfflineIndicator.css';

export const OfflineIndicator: React.FC = () => {
  const { isOnline, isUsingCache } = useOnlineStatus();
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!isOnline) {
      setMessage('You are offline');
      setIsVisible(true);
    } else if (isUsingCache) {
      setMessage('Using cached content');
      setIsVisible(true);
      // Hide the cache message after 3 seconds
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 3000);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isOnline, isUsingCache]);

  if (!isVisible) return null;

  return (
    <div className={`offline-indicator ${isOnline ? 'cached' : 'offline'}`}>
      <div className="offline-content">
        <span className="offline-icon">
          {isOnline ? '📦' : '📡'}
        </span>
        <span className="offline-message">{message}</span>
      </div>
    </div>
  );
}; 